import ApplicationRecord from './ApplicationRecord';
import Link from './Link';
import TeamPeople from './TeamPeople';
import ImageRecord from './ImageRecord';
/**
 * Home page.
 *
 *
 */
export default class CompanyPage
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: -1,
    /**
     * @type {String}
     */
    Path: '',
    /**
     * Absolute path.
     * @type {String}
     */
    URL: '',
    /**
     * @type {String}
     */
    Title: '',
    /**
     * @type {String}
     */
    CertificationText: '',
    /**
     * @type {Boolean}
     */
    ShowInMenus: false,

    /**
     * @type {Object}
     */
    _embedded: {},
  }) {
  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroCaption() {
    return '' + this._getOne('HeroText', String);
  }

  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroImage() {
    return this._getOne('HeroImg', ImageRecord).set('alt', this.HeroCaption);
  }

  /**
   * Get the hero image for mobile screen
   * @return {ImageRecord}
   */
  heroMobileImage() {
    return this._getOne('HeroMobileImg', ImageRecord).set(
      'alt',
      this.HeroCaption
    );
  }

  /**
   * @return {List<TeamPeople}
   */
  team() {
    return this._getMany('Team', p => new TeamPeople(p));
  }

  /**
   * @return {ImageRecord}
   */
  certificationImage() {
    return this._getOne('CertificationImg', ImageRecord);
  }

  /**
   * @return {List<ImageRecord>}
   */
  affiliationImages() {
    return this._getMany('AffiliationImgs', i => new ImageRecord(i));
  }

  /**
   * @return {List<ImageRecord>}
   */
  partenaireImages() {
    return this._getMany('PartenaireImgs', i => new ImageRecord(i));
  }

  /**
   * @return {List<Link>}
   */
  links() {
    return this._getMany('Links', l => new Link(l));
  }
}



// WEBPACK FOOTER //
// ./src/models/CompanyPage.js